// @flow
/* eslint-disable global-require,no-underscore-dangle */
import { createStore as _createStore, applyMiddleware, compose } from 'redux';
import { routerMiddleware } from 'connected-react-router';
import { responsiveStoreEnhancer } from 'redux-responsive';
import thunk from 'redux-thunk';
import createMiddleware from './middleware/clientMiddleware';
import promiseMiddleware from './middleware/promiseMiddleware';
import facebookMiddleware from './middleware/facebookMiddleware';
import googleMiddleware from './middleware/googleMiddleware';
import braintreeMiddleware from './middleware/braintreeMiddleware';
import geolocationMiddleware from './middleware/geolocationMiddleware';
import * as braintreeProvider from './providers/braintree';
import { actionListenersStoreEnhancer } from './components/Decorators/withAnalytics';
import reducer from './stores/reducer';
import config from '../config/config';

declare var __CLIENT__: boolean;
declare var __DEVELOPMENT__: boolean;

export default function createStore(history, client, data) {
  // Sync dispatched route actions to the history
  const middleware = [
    promiseMiddleware,
    facebookMiddleware,
    googleMiddleware,
    geolocationMiddleware,
    braintreeMiddleware(client, braintreeProvider),
    createMiddleware(client),
    routerMiddleware(history),
    thunk.withExtraArgument({
      extraArgument: client
    })
  ];

  let finalCreateStore;
  if (
    (config.isStaging || config.isDevelopment) &&
    __CLIENT__ &&
    !config.isTesting
  ) {
    const { persistState } = require('redux-devtools');

    const composeEnhancers =
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

    finalCreateStore = composeEnhancers(
      responsiveStoreEnhancer,
      applyMiddleware(...middleware),
      persistState(window.location.href.match(/[?&]debug_session=([^&]+)\b/)),
      actionListenersStoreEnhancer
    )(_createStore);
  } else {
    finalCreateStore = compose(
      responsiveStoreEnhancer,
      applyMiddleware(...middleware),
      actionListenersStoreEnhancer
    )(_createStore);
  }

  const store = finalCreateStore(reducer(history), data);

  if (__DEVELOPMENT__ && module.hot) {
    module.hot.accept('./stores/reducer', () => {
      store.replaceReducer(require('./stores/reducer'));
    });
  }

  if (__CLIENT__ && window.Cypress) {
    window.store = store;
  }

  return store;
}
